/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import Raven from 'raven-js';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import BasicI18nSetup from 'I18n/init/setup/BasicI18nSetup';
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';

// Configure the router
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getRootUrl } from 'reports-list-components/utils/urls';

// Apollo Provider
import { ApolloProvider } from '@apollo/client';
import { client } from './graphQL/client';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import rhumbConfig from '../rhumb-config.yaml';
import { reportingReferenceResolvers } from 'reporting-data/public/reference-resolvers';
import userInfo from 'hub-http/userInfo';
import ApplicationAccessDenied from 'dashboard-components/disabled-message/common/application-access-denied';
import ReportsListComponent from 'reports-list-components/ReportsListComponent';
import { LaboratoryContext, laboratoryClient } from 'sales-analytics-lib/laboratoryClient';
import UIApplication from 'UIComponents/app/UIApplication';
import { BUSINESS_UNIT_DROPDOWN_OPTION } from 'reference-resolvers/constants/ReferenceObjectTypes';
import BusinessUnitDropdownReferenceResolver from 'reference-resolvers/resolvers/BusinessUnitDropdownReferenceResolver';
import { renderWithNavCopilot } from 'quartz-core/client-with-copilot';
import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import OnboardingTour from 'onboarding-tours/components/OnboardingTour';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const provideResolvers = ProvideReferenceResolvers(Object.assign({
  [BUSINESS_UNIT_DROPDOWN_OPTION]: BusinessUnitDropdownReferenceResolver
}, reportingReferenceResolvers));
const setUpRaven = user => {
  Raven.setUserContext({
    id: user.user_id,
    email: user.email,
    locale: user.locale
  });
};
const ProvideLaboratory = ({
  children
}) => {
  const [treatments, setTreatments] = useState(null);
  useEffect(() => {
    if (!treatments) {
      laboratoryClient.resolve(treatment => setTreatments(treatment));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx(LaboratoryContext.Provider, {
    value: treatments,
    children: children
  });
};
const setUpRoutes = userInfoResponse => {
  const history = createBrowserHistory({
    basename: getRootUrl()
  });
  const hasReportingAccess = userInfoResponse.user.scopes.includes('reporting-access');
  const ParentComponent = provideResolvers(ReportsListComponent);
  renderWithNavCopilot( /*#__PURE__*/_jsx(CopilotProvider, {
    children: /*#__PURE__*/_jsx(UIApplication, {
      name: "reports-list",
      children: /*#__PURE__*/_jsxs(Router, {
        history: history,
        children: [/*#__PURE__*/_jsx(OnboardingTour, {}), /*#__PURE__*/_jsx(RhumbProvider, {
          config: rhumbConfig,
          history: historyAdapter(history),
          children: /*#__PURE__*/_jsx(ApolloProvider, {
            client: client,
            children: !hasReportingAccess ? /*#__PURE__*/_jsx(ApplicationAccessDenied, {}) : /*#__PURE__*/_jsx(ProvideLaboratory, {
              children: /*#__PURE__*/_jsx(ParentComponent, {
                userInfo: userInfoResponse
              })
            })
          })
        })]
      })
    })
  }), {
    layoutType: 'sidebar'
  });
};
const initializeApp = () => {
  Promise.all([userInfo()]).then(([userInfoResponse]) => {
    const {
      portal,
      user
    } = userInfoResponse;
    BasicI18nSetup.setup({
      lang,
      user,
      portal
    }).then(() => {
      setUpRaven(user);
      setUpRoutes(userInfoResponse);
    });
  });
};
export default initializeApp;